<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Estados CRM - Digitalizador",
            items: [
                {
                    text: "Digitalización",
                    href: "/web/digitalizar/asociar"
                },
                {
                    text: "Estados CRM",
                    active: true
                }
            ],
            loading: false,
            error: "",
            actualizadoEn: null,
            refrescando: null,
            resumen: {
                registros_total: 0,
                registros_en_proceso: 0,
                registros_en_cola: 0,
                jobs_en_cola_total: 0,
                jobs_en_cola_asistentes: 0,
                jobs_en_cola_fichas: 0,
            },
            estados: [],
            estadoSeleccionado: null,
            detalleLoading: false,
            detalleError: "",
            detalleInfo: "",
            detalleRegistros: [],
            detalleTotal: 0,
            detalleLimite: 200,
            liberarEnProcesoLoading: false,
            accionPendienteLoading: {},
            accionDescartarLoading: {},
            comentariosPendientesLoading: false,
            comentariosPendientesError: "",
            comentariosPendientes: [],
            comentariosPendientesTotal: 0,
            comentariosEnviadosLoading: false,
            comentariosEnviadosError: "",
            comentariosEnviados: [],
            comentariosEnviadosTotal: 0,
            comentariosTabActiva: 'pendientes',
            tamanosLoteComentarios: [10, 30, 50, 75, 100],
            loteSeleccionadoComentarios: 50,
            enviarComentariosLoading: false,
            enviarComentariosResultado: "",
        };
    },
    computed: {
        esUsuarioAutorizado() {
            return Number(this.user && this.user.id) === 1;
        },
        desgloseRegistrosEnCola() {
            const estadosColaOrdenados = [
                'sin_preparar',
                'pendiente_envio',
                'pendiente_envio_admin',
                'pendiente_reenvio',
                'reenvio_programado',
                'error_envio',
                'reenviado_admin_error',
            ];

            const mapa = {};
            (this.estados || []).forEach((item) => {
                mapa[String(item.estado_crm)] = Number(item.total || 0);
            });

            return estadosColaOrdenados
                .map((estado) => ({
                    estado,
                    total: mapa[estado] || 0,
                }))
                .filter((item) => item.total > 0);
        },
    },
    methods: {
        async cargarEstados() {
            if (!this.esUsuarioAutorizado) {
                return;
            }

            this.loading = true;
            this.error = "";

            try {
                const response = await axios.get('/api/digitalizar/estados_crm');
                const data = response.data || {};

                if (!data.estado) {
                    this.error = data.mensaje || 'No se pudo cargar el resumen de estados CRM.';
                    return;
                }

                this.resumen = data.resumen || this.resumen;
                this.estados = Array.isArray(data.estados) ? data.estados : [];
                this.actualizadoEn = data.actualizado_en || null;
            } catch (error) {
                if (error && error.response && error.response.status === 403) {
                    window.location.href = '/';
                    return;
                }

                this.error = 'Error al cargar estados CRM.';
            } finally {
                this.loading = false;
            }
        },
        formatDateTime(value) {
            if (!value) {
                return '-';
            }

            return new Date(value).toLocaleString('es-CL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        },
        forceRefresh() {
            this.cargarEstados();
            this.cargarComentariosPendientes();
            this.cargarComentariosEnviados();
            if (this.estadoSeleccionado) {
                this.cargarDetalleEstado(this.estadoSeleccionado);
            }
        },
        async cargarComentariosPendientes() {
            this.comentariosPendientesLoading = true;
            this.comentariosPendientesError = "";

            try {
                const response = await axios.get('/api/digitalizar/comentarios_crm_pendientes', {
                    params: {
                        limit: 50,
                    }
                });

                const data = response.data || {};
                if (!data.estado) {
                    this.comentariosPendientesError = data.mensaje || 'No se pudo cargar el listado de comentarios pendientes.';
                    this.comentariosPendientes = [];
                    this.comentariosPendientesTotal = 0;
                    return;
                }

                this.comentariosPendientes = Array.isArray(data.comentarios) ? data.comentarios : [];
                this.comentariosPendientesTotal = Number(data.total_pendientes || 0);
                this.actualizadoEn = data.actualizado_en || this.actualizadoEn;
            } catch (error) {
                if (error && error.response && error.response.status === 403) {
                    window.location.href = '/';
                    return;
                }

                this.comentariosPendientesError = 'Error al cargar comentarios pendientes CRM.';
                this.comentariosPendientes = [];
                this.comentariosPendientesTotal = 0;
            } finally {
                this.comentariosPendientesLoading = false;
            }
        },
        async cargarComentariosEnviados() {
            this.comentariosEnviadosLoading = true;
            this.comentariosEnviadosError = "";

            try {
                const response = await axios.get('/api/digitalizar/comentarios_crm_enviados', {
                    params: {
                        limit: 50,
                    }
                });

                const data = response.data || {};
                if (!data.estado) {
                    this.comentariosEnviadosError = data.mensaje || 'No se pudo cargar el listado de comentarios enviados.';
                    this.comentariosEnviados = [];
                    this.comentariosEnviadosTotal = 0;
                    return;
                }

                this.comentariosEnviados = Array.isArray(data.comentarios) ? data.comentarios : [];
                this.comentariosEnviadosTotal = Number(data.total_enviados || 0);
                this.actualizadoEn = data.actualizado_en || this.actualizadoEn;
            } catch (error) {
                if (error && error.response && error.response.status === 403) {
                    window.location.href = '/';
                    return;
                }

                this.comentariosEnviadosError = 'Error al cargar comentarios enviados CRM.';
                this.comentariosEnviados = [];
                this.comentariosEnviadosTotal = 0;
            } finally {
                this.comentariosEnviadosLoading = false;
            }
        },
        async enviarComentariosPorLote(limite) {
            if (this.enviarComentariosLoading || this.comentariosPendientesTotal <= 0) {
                return;
            }

            this.loteSeleccionadoComentarios = Number(limite || 50);
            const inicio = performance.now();

            this.enviarComentariosLoading = true;
            this.comentariosPendientesError = "";
            this.enviarComentariosResultado = "";

            try {
                const response = await axios.post('/api/digitalizar/comentarios_crm_enviar_siguientes', {
                    limit: this.loteSeleccionadoComentarios,
                });
                const data = response.data || {};

                if (!data.estado) {
                    this.comentariosPendientesError = data.mensaje || 'No se pudo enviar el lote de comentarios al CRM.';
                    return;
                }

                const duracionBackend = Number(data.duracion_segundos || 0);
                const duracionFrontend = Math.max(0, (performance.now() - inicio) / 1000);
                const duracion = duracionBackend > 0 ? duracionBackend : duracionFrontend;

                this.enviarComentariosResultado = `${data.mensaje || 'Lote de comentarios enviado.'} Tiempo: ${duracion.toFixed(2)}s.`;
                await this.cargarComentariosPendientes();
                await this.cargarComentariosEnviados();
            } catch (error) {
                if (error && error.response && error.response.status === 403) {
                    window.location.href = '/';
                    return;
                }

                const apiMessage = error?.response?.data?.mensaje;
                this.comentariosPendientesError = apiMessage || 'Error al enviar el lote de comentarios al CRM.';
            } finally {
                this.enviarComentariosLoading = false;
            }
        },
        async seleccionarEstado(estadoCrm) {
            const estado = String(estadoCrm || '').trim();
            if (!estado) {
                return;
            }

            this.estadoSeleccionado = estado;
            await this.cargarDetalleEstado(estado);
        },
        async cargarDetalleEstado(estadoCrm) {
            this.detalleLoading = true;
            this.detalleError = "";

            try {
                const response = await axios.get('/api/digitalizar/estados_crm_detalle', {
                    params: {
                        estado_crm: estadoCrm,
                        limit: this.detalleLimite,
                    }
                });

                const data = response.data || {};
                if (!data.estado) {
                    this.detalleError = data.mensaje || 'No se pudo cargar el detalle del estado.';
                    this.detalleRegistros = [];
                    this.detalleTotal = 0;
                    return;
                }

                this.detalleRegistros = Array.isArray(data.registros) ? data.registros : [];
                this.detalleTotal = Number(data.total || 0);
                this.actualizadoEn = data.actualizado_en || this.actualizadoEn;
            } catch (error) {
                if (error && error.response && error.response.status === 403) {
                    window.location.href = '/';
                    return;
                }

                this.detalleError = 'Error al cargar registros del estado seleccionado.';
                this.detalleRegistros = [];
                this.detalleTotal = 0;
            } finally {
                this.detalleLoading = false;
            }
        },
        normalizarRbd(item) {
            return item.rbd_colegio || item.rbd || '-';
        },
        nombreCompleto(item) {
            const partes = [item.nombres, item.apellido_paterno, item.apellido_materno]
                .map(v => String(v || '').trim())
                .filter(v => v.length > 0);
            if (partes.length > 0) {
                return partes.join(' ');
            }

            return '-';
        },
        esPdfUrl(url) {
            const value = String(url || '').toLowerCase();
            if (!value) {
                return false;
            }

            return value.includes('.pdf') || value.includes('contenttype=application%2fpdf') || value.includes('application/pdf');
        },
        imagenesDeFila(row) {
            const items = [];
            const frontal = String(row.imagen_url || '').trim();
            const trasera = String(row.imagen_trasera_url || '').trim();

            if (frontal) {
                items.push({ label: 'Frontal', url: frontal });
            }

            if (trasera) {
                items.push({ label: 'Trasera', url: trasera });
            }

            return items;
        },
        estadoNormalizado(value) {
            return String(value || '')
                .trim()
                .toLowerCase()
                .replace(/\s+/g, '_');
        },
        puedeDescartarEstadoSeleccionado() {
            const estado = this.estadoNormalizado(this.estadoSeleccionado);
            return estado === 'pendiente_envio' || estado === 'sin_preparar';
        },
        esEstadoEnProcesoSeleccionado() {
            return this.estadoNormalizado(this.estadoSeleccionado) === 'en_proceso';
        },
        async liberarRegistrosEnProceso() {
            if (!this.esEstadoEnProcesoSeleccionado() || this.liberarEnProcesoLoading) {
                return;
            }

            const ids = (this.detalleRegistros || [])
                .map((row) => Number(row && row.id))
                .filter((id) => Number.isInteger(id) && id > 0);

            if (!ids.length) {
                this.detalleError = 'No hay registros en pantalla para liberar.';
                return;
            }

            this.liberarEnProcesoLoading = true;
            this.detalleError = "";
            this.detalleInfo = "";

            try {
                const response = await axios.post('/api/digitalizar/liberar_en_proceso_crm', { ids });
                const data = response.data || {};

                if (!data.estado) {
                    this.detalleError = data.mensaje || 'No se pudieron liberar los registros en_proceso.';
                    return;
                }

                this.detalleInfo = data.mensaje || 'Registros liberados correctamente.';

                await this.cargarEstados();
                if (this.estadoSeleccionado) {
                    await this.cargarDetalleEstado(this.estadoSeleccionado);
                }
            } catch (error) {
                if (error && error.response && error.response.status === 403) {
                    window.location.href = '/';
                    return;
                }

                const apiMessage = error?.response?.data?.mensaje;
                this.detalleError = apiMessage || 'Error al liberar registros en_proceso.';
            } finally {
                this.liberarEnProcesoLoading = false;
            }
        },
        async marcarComoPendiente(row) {
            const id = Number(row && row.id);
            if (!id || this.accionPendienteLoading[id]) {
                return;
            }

            this.$set(this.accionPendienteLoading, id, true);
            this.detalleError = "";

            try {
                const response = await axios.post('/api/digitalizar/marcar_pendiente_crm', { id });
                const data = response.data || {};

                if (!data.estado) {
                    this.detalleError = data.mensaje || 'No se pudo cambiar a pendiente_envio.';
                    return;
                }

                await this.cargarEstados();
                if (this.estadoSeleccionado) {
                    await this.cargarDetalleEstado(this.estadoSeleccionado);
                }
            } catch (error) {
                if (error && error.response && error.response.status === 403) {
                    window.location.href = '/';
                    return;
                }

                const apiMessage = error?.response?.data?.mensaje;
                this.detalleError = apiMessage || 'Error al cambiar el estado a pendiente_envio.';
            } finally {
                this.$delete(this.accionPendienteLoading, id);
            }
        },
        async descartarRegistro(row) {
            const id = Number(row && row.id);
            if (!id || this.accionDescartarLoading[id]) {
                return;
            }

            this.$set(this.accionDescartarLoading, id, true);
            this.detalleError = "";

            try {
                const response = await axios.post('/api/digitalizar/descartar_registro_crm', { id });
                const data = response.data || {};

                if (!data.estado) {
                    this.detalleError = data.mensaje || 'No se pudo descartar el registro.';
                    return;
                }

                await this.cargarEstados();
                if (this.estadoSeleccionado) {
                    await this.cargarDetalleEstado(this.estadoSeleccionado);
                }
            } catch (error) {
                if (error && error.response && error.response.status === 403) {
                    window.location.href = '/';
                    return;
                }

                const apiMessage = error?.response?.data?.mensaje;
                this.detalleError = apiMessage || 'Error al descartar el registro.';
            } finally {
                this.$delete(this.accionDescartarLoading, id);
            }
        }
    },
    created() {
        if (!this.esUsuarioAutorizado) {
            window.location.href = '/';
            return;
        }

        this.cargarEstados();
        this.cargarComentariosPendientes();
        this.cargarComentariosEnviados();
        this.refrescando = setInterval(() => {
            this.cargarEstados();
            this.cargarComentariosPendientes();
            this.cargarComentariosEnviados();
        }, 30000);
    },
    beforeDestroy() {
        if (this.refrescando) {
            clearInterval(this.refrescando);
            this.refrescando = null;
        }
    }
};
</script>

<template>
    <Layout>
        <div v-if="!esUsuarioAutorizado"></div>
        <template v-else>
            <PageHeader :title="title" :items="items" />

            <div class="row mb-3">
                <div class="col-12 d-flex justify-content-between align-items-center">
                    <small class="text-muted">Ultima actualización: {{ formatDateTime(actualizadoEn) }}</small>
                    <button class="btn btn-sm btn-primary" @click="forceRefresh" :disabled="loading">
                        Actualizar ahora
                    </button>
                </div>
            </div>

            <div v-if="error" class="alert alert-danger">{{ error }}</div>

            <div class="row">
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-2">En proceso</p>
                            <h4 class="mb-0 text-warning">{{ resumen.registros_en_proceso }}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-2">Registros por faltantes</p>
                            <h4 class="mb-0">{{ resumen.registros_en_cola }}</h4>
                            <div class="mt-2" v-if="desgloseRegistrosEnCola.length">
                                <small class="d-block text-muted" v-for="item in desgloseRegistrosEnCola" :key="`cola-${item.estado}`">
                                    {{ item.estado }}: {{ item.total }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-2">Jobs en cola</p>
                            <h4 class="mb-0">{{ resumen.jobs_en_cola_total }}</h4>
                            <small class="text-muted">Asistentes: {{ resumen.jobs_en_cola_asistentes }} | Fichas: {{ resumen.jobs_en_cola_fichas }}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-2">Total con estado CRM</p>
                            <h4 class="mb-0 text-success">{{ resumen.registros_total }}</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3">
                    <div class="card h-100">
                        <div class="card-body">
                            <h5 class="mb-3">Listado por estado (priorizando en_proceso)</h5>
                            <div class="table-responsive">
                                <table class="table table-sm table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>Estado CRM</th>
                                            <th class="text-right">Cantidad</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="item in estados"
                                            :key="item.estado_crm"
                                            @click="seleccionarEstado(item.estado_crm)"
                                            style="cursor: pointer;"
                                            :class="{ 'table-primary': estadoSeleccionado === item.estado_crm }"
                                        >
                                            <td>{{ item.estado_crm }}</td>
                                            <td class="text-right">{{ item.total }}</td>
                                        </tr>
                                        <tr v-if="!estados.length">
                                            <td colspan="2" class="text-center text-muted">Sin datos</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <small class="text-muted d-block mt-2">Haz click en un estado para ver sus registros.</small>
                        </div>
                    </div>
                </div>

                <div class="col-lg-9">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-2" style="gap: 10px;">
                                <h5 class="mb-0">Detalle de registros: {{ estadoSeleccionado || 'Selecciona un estado' }}</h5>
                                <button
                                    v-if="esEstadoEnProcesoSeleccionado()"
                                    class="btn btn-sm btn-outline-primary"
                                    @click="liberarRegistrosEnProceso"
                                    :disabled="liberarEnProcesoLoading || detalleLoading || !detalleRegistros.length"
                                >
                                    <i v-if="liberarEnProcesoLoading" class="bx bx-loader-alt bx-spin"></i>
                                    <span v-else>Liberar en_proceso (tabla)</span>
                                </button>
                            </div>
                            <p class="text-muted mb-3" v-if="estadoSeleccionado">
                                Mostrando {{ detalleRegistros.length }} de {{ detalleTotal }} registros.
                            </p>

                            <div v-if="detalleError" class="alert alert-danger">{{ detalleError }}</div>
                            <div v-if="detalleInfo" class="alert alert-success">{{ detalleInfo }}</div>

                            <div v-if="!estadoSeleccionado" class="text-muted">
                                Selecciona un estado del panel izquierdo para ver el detalle.
                            </div>

                            <div v-else-if="detalleLoading" class="text-muted">Cargando detalle...</div>

                            <div class="table-responsive" v-else>
                                <table class="table table-sm table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Evento</th>
                                            <th>Cod. evento</th>
                                            <th>Tipo</th>
                                            <th>RUT</th>
                                            <th>Nombre</th>
                                            <th>Celular</th>
                                            <th>Email</th>
                                            <th>RBD</th>
                                            <th>Imagenes</th>
                                            <th>Error CRM</th>
                                            <th>Ult. envio CRM</th>
                                            <th>Creado</th>
                                            <th>Accion</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row in detalleRegistros" :key="`detalle-${row.id}`">
                                            <td>{{ row.id }}</td>
                                            <td>{{ row.evento_id }}</td>
                                            <td>{{ row.evento_codigo || '-' }}</td>
                                            <td>{{ row.tipo_mime || '-' }}</td>
                                            <td>{{ row.rut || '-' }}</td>
                                            <td>{{ nombreCompleto(row) }}</td>
                                            <td>{{ row.celular || '-' }}</td>
                                            <td>{{ row.email || '-' }}</td>
                                            <td>{{ normalizarRbd(row) }}</td>
                                            <td>
                                                <div v-if="imagenesDeFila(row).length" class="d-flex flex-column">
                                                    <a
                                                        v-for="img in imagenesDeFila(row)"
                                                        :key="`${row.id}-${img.label}`"
                                                        :href="img.url"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        class="mb-1"
                                                    >
                                                        <span v-if="esPdfUrl(img.url)" class="badge badge-primary">{{ img.label }} PDF</span>
                                                        <img
                                                            v-else
                                                            :src="img.url"
                                                            :alt="`Imagen ${img.label}`"
                                                            style="width: 58px; height: 58px; object-fit: cover; border-radius: 4px; border: 1px solid #dee2e6;"
                                                            :title="`Ver ${img.label}`"
                                                        >
                                                    </a>
                                                </div>
                                                <span v-else class="text-muted">-</span>
                                            </td>
                                            <td>{{ row.ultimo_error_crm || '-' }}</td>
                                            <td>{{ formatDateTime(row.ultimo_envio_crm_at) }}</td>
                                            <td>{{ formatDateTime(row.created_at) }}</td>
                                            <td>
                                                <div class="d-flex flex-wrap" style="gap: 6px;">
                                                    <button
                                                        class="btn btn-sm btn-outline-warning"
                                                        @click="marcarComoPendiente(row)"
                                                        :disabled="row.estado_crm === 'pendiente_envio' || !!accionPendienteLoading[row.id]"
                                                        title="Dejar pendiente"
                                                        aria-label="Dejar pendiente"
                                                        v-if="estadoSeleccionado !== 'pendiente_envio'"
                                                    >
                                                        <i v-if="accionPendienteLoading[row.id]" class="bx bx-loader-alt bx-spin"></i>
                                                        <i v-else class="bx bx-time-five"></i>
                                                    </button>

                                                    <template v-if="puedeDescartarEstadoSeleccionado()">
                                                        <button
                                                            class="btn btn-sm btn-outline-secondary"
                                                            @click="descartarRegistro(row)"
                                                            :disabled="!!accionDescartarLoading[row.id]"
                                                            title="Descartar"
                                                            aria-label="Descartar"
                                                        >
                                                            <i v-if="accionDescartarLoading[row.id]" class="bx bx-loader-alt bx-spin"></i>
                                                            <i v-else class="bx bx-block"></i>
                                                        </button>
                                                    </template>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="!detalleRegistros.length">
                                            <td colspan="14" class="text-center text-muted">No hay registros para este estado.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex flex-wrap justify-content-between align-items-center mb-3" style="gap: 10px;">
                                <div>
                                    <h5 class="mb-1">Comentarios pendientes de envío a CRM</h5>
                                    <small class="text-muted">
                                        Pendientes: {{ comentariosPendientesTotal }} | Enviados: {{ comentariosEnviadosTotal }}
                                    </small>
                                </div>
                                <div class="d-flex flex-wrap" style="gap: 6px;">
                                    <button
                                        v-for="tamano in tamanosLoteComentarios"
                                        :key="`lote-${tamano}`"
                                        class="btn btn-sm"
                                        :class="loteSeleccionadoComentarios === tamano ? 'btn-success' : 'btn-outline-success'"
                                        @click="enviarComentariosPorLote(tamano)"
                                        :disabled="enviarComentariosLoading || comentariosPendientesLoading || comentariosPendientesTotal <= 0"
                                    >
                                        <i v-if="enviarComentariosLoading && loteSeleccionadoComentarios === tamano" class="bx bx-loader-alt bx-spin"></i>
                                        <span v-else>Enviar {{ tamano }}</span>
                                    </button>
                                </div>
                            </div>

                            <div v-if="enviarComentariosResultado" class="alert alert-success py-2">
                                {{ enviarComentariosResultado }}
                            </div>

                            <div v-if="comentariosPendientesError" class="alert alert-danger py-2">
                                {{ comentariosPendientesError }}
                            </div>

                            <div v-if="comentariosEnviadosError" class="alert alert-danger py-2">
                                {{ comentariosEnviadosError }}
                            </div>

                            <ul class="nav nav-tabs mb-3">
                                <li class="nav-item">
                                    <button
                                        type="button"
                                        class="nav-link"
                                        :class="{ active: comentariosTabActiva === 'pendientes' }"
                                        @click="comentariosTabActiva = 'pendientes'"
                                    >
                                        Pendientes ({{ comentariosPendientesTotal }})
                                    </button>
                                </li>
                                <li class="nav-item">
                                    <button
                                        type="button"
                                        class="nav-link"
                                        :class="{ active: comentariosTabActiva === 'enviados' }"
                                        @click="comentariosTabActiva = 'enviados'"
                                    >
                                        Enviados ({{ comentariosEnviadosTotal }})
                                    </button>
                                </li>
                            </ul>

                            <div v-if="comentariosTabActiva === 'pendientes' && comentariosPendientesLoading" class="text-muted">Cargando comentarios pendientes...</div>
                            <div v-if="comentariosTabActiva === 'enviados' && comentariosEnviadosLoading" class="text-muted">Cargando comentarios enviados...</div>

                            <div class="table-responsive" v-if="comentariosTabActiva === 'pendientes' && !comentariosPendientesLoading">
                                <table class="table table-sm table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Colegio</th>
                                            <th>RBD</th>
                                            <th>Creado por</th>
                                            <th>Comentario</th>
                                            <th>Estado sync</th>
                                            <th>Intentos</th>
                                            <th>Ult. envio</th>
                                            <th>Ingreso</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in comentariosPendientes" :key="`comentario-${item.id}`">
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.colegio_nombre || '-' }}</td>
                                            <td>{{ item.rbd || item.colegio_rbd || '-' }}</td>
                                            <td>{{ item.usuario_nombre || '-' }}</td>
                                            <td style="max-width: 420px; white-space: normal;">
                                                {{ item.comentario || '-' }}
                                            </td>
                                            <td>{{ item.sync_estado || 'pendiente' }}</td>
                                            <td>{{ item.sync_intentos || 0 }}</td>
                                            <td>{{ formatDateTime(item.sync_enviado_at) }}</td>
                                            <td>{{ formatDateTime(item.created_at) }}</td>
                                        </tr>
                                        <tr v-if="!comentariosPendientes.length">
                                            <td colspan="9" class="text-center text-muted">No hay comentarios pendientes.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="table-responsive" v-if="comentariosTabActiva === 'enviados' && !comentariosEnviadosLoading">
                                <table class="table table-sm table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Colegio</th>
                                            <th>RBD</th>
                                            <th>Creado por</th>
                                            <th>Comentario</th>
                                            <th>Estado sync</th>
                                            <th>Intentos</th>
                                            <th>Fecha envío</th>
                                            <th>Ingreso</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in comentariosEnviados" :key="`comentario-enviado-${item.id}`">
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.colegio_nombre || '-' }}</td>
                                            <td>{{ item.rbd || item.colegio_rbd || '-' }}</td>
                                            <td>{{ item.usuario_nombre || '-' }}</td>
                                            <td style="max-width: 420px; white-space: normal;">
                                                {{ item.comentario || '-' }}
                                            </td>
                                            <td>{{ item.sync_estado || '-' }}</td>
                                            <td>{{ item.sync_intentos || 0 }}</td>
                                            <td>{{ formatDateTime(item.sync_enviado_at) }}</td>
                                            <td>{{ formatDateTime(item.created_at) }}</td>
                                        </tr>
                                        <tr v-if="!comentariosEnviados.length">
                                            <td colspan="9" class="text-center text-muted">No hay comentarios enviados.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Layout>
</template>
